import styled from "styled-components";
import {
  BoxTab,
  BoxTabEach,
  TabHeader,
  TabSub,
} from "../../../pages/YachtClubViewDetails";
import { Colors, Text } from "../../../config/Constants";
import Button from "../../Button";
import { titleCase } from "../../../helper";

interface Props {
  paymentStatus: string; //"Pending" | "Success";
  paymentMode: string; //"cash" | "cheque" | "online";
  parkingSpace: string;
  chequeNumber: string;
  transactionAmount: string;
  enteredBerthPayment: string;
  setEnteredBerthPayment: React.Dispatch<React.SetStateAction<string>>;
  paymentInputError: string;
  setPaymentInputError: React.Dispatch<React.SetStateAction<string>>;
  handlePaymentSubmit: () => void;
  setBerthPaymentDetailsModal: (a: boolean) => void;
}
interface ColorProps {
  color: string;
}
interface inputProps {
  isError: string;
}

const BerthRentalRejection = ({
  paymentMode,
  paymentStatus,
  parkingSpace,
  chequeNumber,
  transactionAmount,
  enteredBerthPayment,
  setEnteredBerthPayment,
  paymentInputError,
  setPaymentInputError,
  handlePaymentSubmit,
  setBerthPaymentDetailsModal,
}: Props) => {
  const getImageAndTagline = (
    imageName: string,
    color: string,
    tagLine: string
  ) => {
    return (
      <>
        <SuccessFailureImage
          src={require(`../../../assets/images/${imageName}.png`)}
          alt="payment"
        />
        <TagLineColor color={color}>{tagLine}</TagLineColor>
      </>
    );
  };
  const getInputTag = (placeholder: string) => {
    return (
      <div>
        <InputTag
          type="text"
          placeholder={placeholder}
          value={enteredBerthPayment}
          onChange={(e) => {
            setPaymentInputError("");
            setEnteredBerthPayment(e.target.value);
          }}
          isError={paymentInputError}
        />
        {paymentInputError && <ErrorDiv>{paymentInputError}</ErrorDiv>}
      </div>
    );
  };

  return (
    <BoxTab style={{ padding: '1.25rem 0rem 0rem' }}>
        <BoxTabEach>
          <TabHeader>Parking Space</TabHeader>
          <TabSub>{titleCase(parkingSpace)}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Payment Mode</TabHeader>
          <DispFlex>
            <TabSub style={{ display: "flex" }}>
              {paymentStatus !== "Success" && (
                <EditImage
                  src={require("../../../assets/images/icn_edit.png")}
                  alt="edit"
                  onClick={() => {
                    setPaymentInputError("");
                    setBerthPaymentDetailsModal(true);
                  }}
                />
              )}
              {titleCase(paymentMode)}
            </TabSub>
            {paymentStatus === "Success" ? (
              <PaymentNumber>
                {paymentMode === "cheque" && chequeNumber}
                {paymentMode === "cash" && transactionAmount + " QAR"}
              </PaymentNumber>
            ) : (
              paymentMode !== "online" &&
              (paymentMode === "cheque"
                ? getInputTag(Text.enterCheckNum)
                : getInputTag(Text.enterAmount))
            )}
          </DispFlex>
        </BoxTabEach>
        <BoxTabEach style={{ gridColumn: "4 / span 1" }}>
      {paymentStatus === "Pending" &&
        (paymentMode !== "online" ? (
          <ButtonWrapper>
            <Button
              label={Text.paymentReceived}
              variant="filled"
              color={Colors.solidRed}
              size="medium"
              onClick={handlePaymentSubmit}
            />
          </ButtonWrapper>
        ) : (
          <ImageWrapper>
            {getImageAndTagline(
              "payment_pending",
              Colors.saffronApprox,
              Text.payementPending
            )}
          </ImageWrapper>
        ))}
      {paymentStatus === "Success" && (
        <ImageWrapper>
          {getImageAndTagline(
            "payment_success",
            Colors.laPalma,
            Text.paymentCompleted
          )}
        </ImageWrapper>
      )}
      </BoxTabEach>
    </BoxTab>
  );
};

export default BerthRentalRejection;

const ButtonWrapper = styled.div`
  margin-top: 1rem;
  width: 16.25rem;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-top: -2rem;
  @media only screen and (max-width: 980px) {
    margin-top: 1rem;
  }
`;

const TagLineColor = styled.div<ColorProps>`
  color: ${(props) => props.color};
  font-family: "Poppins-Medium";
  font-size: 1rem;
`;

const DispFlex = styled.div`
  display: flex;
  gap: 1rem;
`;

const SuccessFailureImage = styled.img`
  width: 72px;
  height: 72px;
`;

const InputTag = styled.input<inputProps>`
  border: none;
  border-bottom: 1px solid
    ${(props) => (props.isError ? Colors.appleRed : Colors.black + "1A")};
  background: ${Colors.zirconApprox};
  ${Colors.zirconApprox};
  font-family: "Poppins-Book";
  color: ${(props) =>
    props.isError ? Colors.appleRed : Colors.secondaryBlack};
  ::placeholder {
    font-size: 0.75rem;
    font-family: "Poppins-Book";
    color: ${(props) =>
      props.isError ? Colors.appleRed : Colors.dustyGrayApprox};
  }
  :focus {
    outline: none;
  }
`;

const PaymentNumber = styled.div`
  font-family: "Poppins-Medium";
  font-size: 0.875rem;
  color: ${Colors.appleGreen};
`;

const ErrorDiv = styled.div`
  color: ${Colors.appleRed};
  font-family: "Poppins-Book";
  font-size: 0.625rem;
  margin-top: 0.35rem;
`;

const EditImage = styled.img`
  width: 14px;
  height: 14px;
  margin-right: 0.375rem;
  cursor: pointer;
`;
